/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Contactcodetreecount3Inputs */

const en_entity_contactcodetreecount3 = /** @type {(inputs: Entity_Contactcodetreecount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Code Tree Count`)
};

const de_entity_contactcodetreecount3 = /** @type {(inputs: Entity_Contactcodetreecount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt Code-Baum-Anzahl`)
};

/**
* | output |
* | --- |
* | "Contact Code Tree Count" |
*
* @param {Entity_Contactcodetreecount3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_contactcodetreecount3 = /** @type {((inputs?: Entity_Contactcodetreecount3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Contactcodetreecount3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_contactcodetreecount3(inputs)
	return de_entity_contactcodetreecount3(inputs)
});
export { entity_contactcodetreecount3 as "entity_contactCodeTreeCount" }